import { infoService } from '../../api/services/infoService';
import globalCacheManager from './globalCacheManager';

const CACHE_KEY = 'price';

class PriceCache {
  constructor() {
    this.data = null;
    this.pendingPromise = null;
    this.lastFetchTime = null;
  }

  /**
   * 가격 목록 — GET /info/v3/price/list (Bundle 미포함)
   */
  async fetchData(forceRefresh = false) {
    if (!forceRefresh && this.data) {
      return this.data;
    }

    if (this.pendingPromise && !forceRefresh) {
      return this.pendingPromise;
    }

    this.pendingPromise = (async () => {
      try {
        const response = await infoService.getPrices({});
        if (response.success && response.data) {
          this.setData(response.data);
          return this.data;
        }
        console.error('[PriceCache] Failed to fetch prices:', response.error);
        return this.data || [];
      } catch (error) {
        console.error('[PriceCache] Error fetching prices:', error);
        return this.data || [];
      } finally {
        this.pendingPromise = null;
      }
    })();

    return this.pendingPromise;
  }

  getData() {
    return this.data;
  }

  setData(data) {
    const activePrices = (data || []).filter((price) => price.is_deleted !== 1);
    this.data = activePrices;
    this.lastFetchTime = Date.now();
  }

  invalidate() {
    this.data = null;
    this.pendingPromise = null;
    this.lastFetchTime = null;
  }

  getLastFetchTime() {
    return this.lastFetchTime;
  }
}

const priceCache = new PriceCache();

globalCacheManager.register(CACHE_KEY, priceCache);

export const fetchPriceListCached = async (forceRefresh = false) => {
  return await priceCache.fetchData(forceRefresh);
};

export const getPriceListCached = () => {
  return priceCache.getData();
};

export const invalidatePriceCache = () => {
  priceCache.invalidate();
};

export default priceCache;
